var render, staticRenderFns
import script from "./blockCanvasCommon.vue?vue&type=script&lang=js"
export * from "./blockCanvasCommon.vue?vue&type=script&lang=js"
import style0 from "./blockCanvasCommon.vue?vue&type=style&index=0&id=2b776ce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports